import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-regle-cle"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "regle-pastille__contenu" }
const _hoisted_4 = { class: "regle-pastille__titre" }
const _hoisted_5 = { class: "regle-pastille__texte" }
const _hoisted_6 = { class: "regle-pastille__source" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!

  return (_ctx.regle)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["regle-pastille", { 'regle-pastille--mise-en-avant': _ctx.estMiseEnAvant }]),
        "data-regle-cle": _ctx.cle
      }, [
        _createVNode(_component_Popper, {
          arrow: "",
          hover: "",
          placement: _ctx.placement,
          class: "regle-pastille__popper"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.regle.titre), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.regle.texte), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.regle.source), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "regle-pastille__bouton",
              "aria-label": _ctx.regle.titre,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              onDblclick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("svg", {
                "aria-hidden": "true",
                class: "regle-pastille__icone",
                focusable: "false",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  fill: "currentColor",
                  d: "M12 21.5C10.65 20.65 8.2 20 6.5 20C4.85 20 3.15 20.3 1.75 21.05C1.65 21.1 1.6 21.1 1.5 21.1C1.25 21.1 1 20.85 1 20.6V6C1.6 5.55 2.25 5.25 3 5C4.11 4.65 5.33 4.5 6.5 4.5C8.45 4.5 10.55 4.9 12 6C13.45 4.9 15.55 4.5 17.5 4.5C18.67 4.5 19.89 4.65 21 5C21.75 5.25 22.4 5.55 23 6V20.6C23 20.85 22.75 21.1 22.5 21.1C22.4 21.1 22.35 21.1 22.25 21.05C20.85 20.3 19.15 20 17.5 20C15.8 20 13.35 20.65 12 21.5M12 8V19.5C13.35 18.65 15.8 18 17.5 18C18.7 18 19.9 18.15 21 18.5V7C19.9 6.65 18.7 6.5 17.5 6.5C15.8 6.5 13.35 7.15 12 8M13 11.5C14.11 10.82 15.6 10.5 17.5 10.5C18.41 10.5 19.26 10.59 20 10.78V9.23C19.13 9.08 18.29 9 17.5 9C15.73 9 14.23 9.28 13 9.84V11.5M17.5 11.67C15.79 11.67 14.29 11.93 13 12.46V14.15C14.11 13.5 15.6 13.16 17.5 13.16C18.54 13.16 19.38 13.24 20 13.4V11.9C19.13 11.74 18.29 11.67 17.5 11.67M20 14.57C19.13 14.41 18.29 14.33 17.5 14.33C15.67 14.33 14.17 14.6 13 15.13V16.82C14.11 16.16 15.6 15.83 17.5 15.83C18.54 15.83 19.38 15.91 20 16.07V14.57Z"
                })
              ], -1)
            ]))], 40, _hoisted_2)
          ]),
          _: 1
        }, 8, ["placement"])
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}